import { render, staticRenderFns } from "./get.vue?vue&type=template&id=3c8d6e85&scoped=true&"
import script from "./get.vue?vue&type=script&lang=js&"
export * from "./get.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d6e85",
  null
  
)

export default component.exports